import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWeaveInsuranceEligibilityIllustration = lazy(
  () => import('./svg-components/weave-insurance-eligibility-illustration')
);

const WeaveInsuranceEligibilityIllustration = ({
  assetsFallbackProps = {},
  customFallback,
  ...rest
}: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWeaveInsuranceEligibilityIllustration {...rest} />
  </Suspense>
);

export default WeaveInsuranceEligibilityIllustration;
